// Mobile menu for the ChairLounge header (sections/cl-header.liquid).
if (!customElements.get('cl-header')) {
  customElements.define(
    'cl-header',
    class ClHeader extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-cl-menu-toggle]');
        this.drawer = this.querySelector('[data-cl-drawer]');
        if (!this.toggle || !this.drawer) return;

        this.onToggle = () => this.setOpen(!this.drawer.classList.contains('is-open'));
        this.onLinkClick = (e) => e.target.closest('a') && this.setOpen(false);
        this.onKeydown = (e) => {
          if (e.key !== 'Escape' || !this.drawer.classList.contains('is-open')) return;
          this.setOpen(false);
          this.toggle.focus();
        };
        this.toggle.addEventListener('click', this.onToggle);
        this.drawer.addEventListener('click', this.onLinkClick);
        document.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
      }

      setOpen(open) {
        this.drawer.classList.toggle('is-open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
        this.toggle.setAttribute('aria-label', open ? this.toggle.dataset.labelClose : this.toggle.dataset.labelOpen);
        this.toggle.querySelector('[data-icon-open]').hidden = open;
        this.toggle.querySelector('[data-icon-close]').hidden = !open;
      }
    }
  );
}
